import apiFetch from '@wordpress/api-fetch'
import FrontPageEnum from '../enumerators/front-page.enum'

export default class SocialWallComponent {
    constructor() {
        SocialWallComponent.init()
    }

    static init() {
        const container = '[data-element="social-wall"]'
        if ($(container).length > 0 && !$(container).is(':hidden')) {
            import(
                '@wordpress/api-fetch' /* webpackChunkName: "scripts/wordpress_api_fetch" */
            ).then(({ default: apiFetch }) => {
                import('@wordpress/i18n' /* webpackChunkName: "scripts/wordpress_i18n" */).then(
                    ({ __ }) => {
                        apiFetch({
                            path: IRISCollectionCustomer.irisSsoInstagramPath,
                            method: 'post',
                            data: { limit: 4 },
                        })
                            .then((result) => {
                                $(container).html(result.render)
                                import(
                                    '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                                ).then(({ HcLazyload }) => {
                                    HcLazyload.update()
                                })
                            })
                            .catch((e) => {
                                $(container).html(IRISCollectionCustomer.irisSsoInstagramError)
                            })
                    },
                )
            })
        }
    }
}
